import React, { Component } from "react";
import PropTypes from "prop-types";
import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { renderToString } from "react-dom/server";
import clsx from "clsx";

import { storageKeys } from "settings";
import {
  APIHandler,
  Image,
  StorageHandler,
  Progress,
  DataHandler,
  SharingPopup,
} from "C4";

const shareAnalytics = (name, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = "";
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, "levelii", name, value, value).then(
        () => {}
      );
    });
  });
};
export default class SubAppButton extends Component {
  constructor(props) {
    super(props);

    const { src, customName, appId } = this.props;

    let newSrc = src;
    const name = customName.length > 0 ? customName : "Icon-180";
    if (newSrc.length === 0) {
      if (appId > 500) {
        newSrc = `https://front.travpromobile.com/${appId}/logo_white.png`;
      } else {
        newSrc = `https://cdn.travpromobile.com/apptool/app/${appId}/images/${name}.png`;
      }
    }
    this.state = {
      appId,
      pageId: 0,
      src: newSrc,
      redir: "",
      firstName: "",
      lastName: "",
    };
  }

  componentDidMount() {
    this.loadUserData();
  }

  loadUserData() {
    StorageHandler.load(storageKeys.user).then((res) => {
      this.setState({
        firstName: res.first_name,
        lastName: res.last_name,
      });
    });
  }

  render() {
    const { src, firstName, lastName } = this.state;
    const {
      appId,
      size,
      progress: userProgress,
      name,
      type,
      chapterId,
      email,
      locked,
      pageId,
      uri,
      numChapters,
      backgroundImage,
      percentageCompleted,
    } = this.props;

    let percentage = Math.round(
      (userProgress.progress / userProgress.total_pages) * 100
    );
    if (numChapters > 1) {
      percentage = percentageCompleted;
    }
    const appURL = window.location.origin;

    let buttonText;
    switch (percentage) {
      case 100:
        buttonText = i18n.translate("trainingScreens.restart");
        break;
      case undefined:
      case 0:
        buttonText = i18n.translate("trainingScreens.start");
        break;
      default:
        buttonText = i18n.translate("trainingScreens.continue");
    }

    if (type !== "training") {
      buttonText = i18n.translate("trainingScreens.review");
    }

    let programUrl = uri;
    if (numChapters === 1 && percentage >= 100) {
      programUrl = `https://academy.travpromobile.com/training/${appId}/${email}/${chapterId}/${pageId}/${
        type === "training" ? "true" : ""
      }/true/?redirurl=${appURL}/main/${type}`;
    } else if (numChapters === 1) {
      programUrl = `https://academy.travpromobile.com/${type}/${appId}/${email}/${chapterId}/${pageId}/${
        type === "training" ? "true" : ""
      }/true/?redirurl=${appURL}/main/${type}`;
    }

    if (type !== "training" && numChapters === 1) {
      programUrl = `https://academy.travpromobile.com/retain/${appId}/${email}/${chapterId}/0/true/true?redirurl=${appURL}/main/${type}`;
    }

    const badgeUrl = `https://stack.travpromobile.com/download.php?url=https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}&name=${name}.png&fileType=png`;
    console.log(backgroundImage);
    return (
      <div className={clsx("subApp__Card", { locked })} key={chapterId}>
        <a
          href={programUrl}
          onClick={() => {
            shareAnalytics("open-training", chapterId);
          }}
          {...(numChapters > 1 ? { target: "_blank" } : {})}
        >
          {locked && (
            <div className="subApp__Card--locked">
              <FontAwesomeIcon icon={["fas", "lock"]} />{" "}
              <p>{i18n.translate("trainingScreens.unlockSubtitle")}</p>
            </div>
          )}
          <img
            src={`${backgroundImage.replace(
              "s3.amazonaws.com/developertool",
              "travprocdn.imgix.net"
            )}?width=500`}
            className="subApp__Card--backgroundImage"
          />
          <div className="subApp__Card--content">
            <div className="overlay gradient" />
            <img src={src} className="logo" />
            <button>{buttonText}</button>
            <div className="subApp__Card--start">
              {type === "training" && (
                <Progress id={`SubAppButton_${src}`} value={percentage} />
              )}
            </div>
          </div>
        </a>
        {firstName && percentage >= 100 && numChapters === 1 && (
          <a
            href={badgeUrl}
            className="badge"
            // data-fancybox="badge"
            // data-src={badgeUrl}
            // data-options={JSON.stringify({
            //   buttons: ["share", "close"],
            //   share: {
            //     tpl: renderToString(<SharingPopup url={badgeUrl} />),
            //   },
            // })}
          >
            <FontAwesomeIcon icon={["fas", "file-certificate"]} />{" "}
            {i18n.translate("general.viewBadge")} <br />{" "}
            {i18n.translate("general.viewBadge2")}
          </a>
        )}
      </div>
    );
  }
}

SubAppButton.propTypes = {
  appId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  email: PropTypes.string,
  customName: PropTypes.string,
  src: PropTypes.string,
  locked: PropTypes.bool,
  size: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
  chapterId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  progress: PropTypes.shape({
    progress: PropTypes.number,
    last_page: PropTypes.number,
    total_pages: PropTypes.number,
    inserted_at: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  name: PropTypes.string,
  uri: PropTypes.string,
  numChapters: PropTypes.number,
  percentageCompleted: PropTypes.number,
};

SubAppButton.defaultProps = {
  appId: -1,
  chapterId: -1,
  customName: "",
  src: "",
  locked: false,
  size: { height: 150, width: 60 },
  pageId: 0,
  email: "",
  name: "Level II Chapter",
  comingSoon: false,
  numChapters: 1,
  uri: "",
  percentageCompleted: 0,
};
